import { FormGroup } from '@angular/forms';
import { IDefaultListFilter } from '../default-list/default-list-filter.interface';
import { Output, EventEmitter } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';

export class BaseDefaultListFilterComponent implements IDefaultListFilter{

    constructor(protected datePipe: DatePipe
    ){
    }

    public filterFormGroup: FormGroup = new FormGroup({});
    protected defaultFilterValues: { [key: string]: any } = {};
    collapsed: boolean = true;
    public FilterDescription: string = '';

    @Output() FilterApplied = new EventEmitter();

    public ApplyFilter(){
        this.FilterApplied.emit(this.filterFormGroup.value);
        this.collapsed = true;
        //this.saveFilterToStorage('filter');
        this.SetFilterDescription(); 
    }

    public SetFilterDescription(){
        this.FilterDescription = '';
    }

    GetPropertyValue(value, type){
        switch(type){
            case 'date': return this.datePipe.transform(new Date(value['year'], value['month'] - 1, value['day']), 'dd.MM.yyyy');
            case 'string': return value;
            case 'number': return value;
        }
    }

    ResetFilter() {
        this.SetInitParameters();
        //this.resetFilterToDefault();
        this.SetFilterDescription();
        this.ApplyFilter();
    }

    SetInitParameters() {
    }

    //  saveFilterToStorage(storageKey: string): void {
    //     const user = sessionStorage.getItem('sel-user');
    //     if (user) {
    //         const parsedUser = JSON.parse(user);
    //         const username = parsedUser.Username;
    
    //         if (username && !this.isObjectEmpty(this.defaultFilterValues)) {
    //             const routeKey = this.getRouteKey();
    //             const filterKey = `${storageKey}_${username}_${routeKey}`;
    //             localStorage.setItem(filterKey, JSON.stringify(this.filterFormGroup.value));
    //         }
    //     }
    // }

    //  loadFilterFromStorage(storageKey: string ): void {
    //     const user = sessionStorage.getItem('sel-user');
    //     if (user) {
    //         const parsedUser = JSON.parse(user);
    //         const username = parsedUser.Username;
    
    //         if (username) {
    //             const routeKey = this.getRouteKey();
    //             const filterKey = `${storageKey}_${username}_${routeKey}`;
    //             const savedFilter = localStorage.getItem(filterKey);
    
    //             if (savedFilter) {
    //                 const filterData = JSON.parse(savedFilter);
    
    //                 // Postavljanje učitanih vrednosti u formu
    //                 for (const key of Object.keys(filterData)) {
    //                     if (this.filterFormGroup.get(key)) {
    //                         this.filterFormGroup.get(key).setValue(filterData[key]);
    //                     }
    //                 }
    //                 return;
    //             }
    //         }
    //     }
    
    //     // Ako nema sačuvanih vrednosti, postavi default vrednosti
    //     this.resetFilterToDefault();
    // }

    //  resetFilterToDefault(): void {
    //     Object.keys(this.defaultFilterValues).forEach(key => {
    //         if (this.filterFormGroup.get(key)) {
    //             this.filterFormGroup.get(key).setValue(this.defaultFilterValues[key]);
    //         }
    //     });

    //     this.saveFilterToStorage('filter');
    // }

    // protected getRouteKey(): string {
    //     // Pretpostavka da koristiš `ActivatedRoute` za rute
    //     const route = this.router.url; // ili neka prilagođena logika
    //     return route.replace(/\//g, '_'); // Zamenjujemo `/` sa `_` da bi bio validan ključ
    // }

    // private isObjectEmpty(obj: any): boolean {
    //     return obj && Object.keys(obj).length === 0;
    // }
    
}